<template>
    <div>
        <a href="javascript:void(0)" class="view-profile" @click="startChat">SEND MESSAGE</a>
        <div class="chat-block single-chat-blk" v-if="showChatFlag">
            <div class="chat-header">
                <p>{{data.name}}</p>
                <ul>
                    <!--<li>-->
                        <!--<a href="javascript:void(0)">-->
                            <!--<img src="@/assets/img/minus.svg"/>-->
                        <!--</a>-->
                    <!--</li>-->
                    <li>
                        <a href="javascript:void(0)" @click="closeChat">
                            <img src="@/assets/img/cancel.svg"/>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="chat-body"></div>
            <div class="chat-footer">
                <input type="text" placeholder="Enter Message" v-model="message" @keyup.enter="onEnter"/>
            </div>
        </div>
    </div>
</template>

<script>
    // import { io } from "socket.io-client"
    import $ from "jquery"
    import moment from 'moment'
    export default {
        name: 'Chat',
        props: ['data'],
        data () {
            return {
                msg: 'Welcome to Your Vue.js App',
                message: '',
                userData: '',
                showChatFlag: false,
                socket: io(process.env.socketUrl)
            }
        },
        mounted() {
            var userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                this.userData = JSON.parse(userdata)
            }
            // Message from server
            this.socket.on('getChat', (messages) => {
                let $this = this
                $.each(messages, function (key, val) {
                    if(val.receiverId === $this.userData.user.id){
                        let text = $this.receiverChat(val.message)
                        $this.pushChatDom(text)
                    } else {
                        let text = $this.senderChat(val.message)
                        $this.pushChatDom(text)
                    }
                })
            });
            this.findReceiver()
        },
        methods: {
            startChat: function (event) {
                this.showChatFlag = true
                let getChat = {
                    senderId: this.userData.user.id,
                    receiverId: this.data._id
                }
                this.socket.emit("loadChat", getChat)
            },
            closeChat: function (event) {
                this.showChatFlag = false
            },
            senderChat: function (event) {
                return '<div class="chat-right"><div> <p>'+event+'</p> <span>'+moment(new Date()).format('LT')+'</span> </div></div>'
            },
            receiverChat: function (event) {
                return '<div class="chat-left"><div> <p>'+event+'</p> <span>'+moment(new Date()).format('LT')+'</span> </div></div>'
            },
            pushChatDom: function (event){
                $('.chat-body').append(event)
                this.scrollAnimation()
            },
            findReceiver: function (event) {
                let $this = this
                this.socket.on('findReceiver', (id) => {
                    if(id.receiverId === $this.userData.user.id){
                        let text = $this.receiverChat(id.message)
                        $this.pushChatDom(text)
                    }
                });
            },
            onEnter: function (event) {
                let userChat = {
                    senderId: this.userData.user.id,
                    receiverId: this.data._id,
                    message: this.message
                }
                let text = this.senderChat(this.message)
                this.pushChatDom(text)
                this.socket.emit("chat", userChat);
                this.message = ''
                this.scrollAnimation()
            },
            scrollAnimation: function (event) {
                $('.chat-body').stop().animate({
                    scrollTop: $('.chat-body')[0].scrollHeight
                }, 800)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/Chat.vue